import { TextField } from "@material-ui/core";
import trI18n from '@/common/utils/trI18n';
import useTranslationSubscription from "@/hooks/useTranslation";

export default function IPRestrictionSetting({
  //state
  usingIpAddressRestrict,
  error,
  ipAddressRange,
  changeIpAddressRange,
  //setState
  setError,
  setIsEdited,
  setUsingIpAddressRestrict,
  setIpAddressRange,
  //event
  onChangeUsingIpAddressRestrict,
  onChangeIpAddressRange
}) {
  useTranslationSubscription();
  
  return (
    <>
      <div className="org-profile-wrap-footer">
        <div
          className="org-profile-wrap-title"
          data-cy="org-profile-header-title"
        >
          {trI18n("LABEL-FUNCTION-IP-RESTRICTION")}
        </div>
        <div  className="horizontal-field">
            <div className="title-name setting-ai-function">
                {trI18n("APPLY_IP_ADDRESS_RESTRICTION")}
            </div>
            <div className="switch-check setting-ai-function"> 
                <input
                    name="ipAddressRestrict"
                    id="setting-ipAddress-switch-id"
                    type="checkbox"
                    checked={usingIpAddressRestrict}
                    onChange={e => {
                        const usingIpAddressRestrictValue = !usingIpAddressRestrict;
                        onChangeUsingIpAddressRestrict(
                            usingIpAddressRestrictValue,
                            setUsingIpAddressRestrict,
                            error,
                            setError, 
                            setIsEdited
                        );
                    }}
                />
                <label htmlFor="setting-ipAddress-switch-id"></label>
            </div>
        </div>
        <div className="groupSettingItem ipaddress-range">
          <div className="embeddedCode-label my-3">
            {trI18n("IP_ADDRESS_ORG_SETTING_DESCRIPTION")}
          </div>
          <TextField
            placeholder={trI18n("IP_ADDRESS_RANGE_PLACEHOLDER")}
            multiline
            fullWidth
            variant="outlined"
            minRows={5}
            maxRows={5}
            className="form-control-wrapInput form-control-hg40"
            value={ipAddressRange}
            onChange={e =>
              onChangeIpAddressRange(
                e.target.value,
                setIpAddressRange,
                setIsEdited
              )
            }
            onBlur={e =>
              changeIpAddressRange(
                e.target.value,
                setIpAddressRange,
                error,
                setError,
                setIsEdited
              )
            }
            disabled={!usingIpAddressRestrict}
            error={error?.ipAddressRange ? true : false}
            helperText={error?.ipAddressRange}
          />
        </div>
      </div>
    </>
  );
}
